// Floor sale, step 4: how the customer pays. From the phone the bill is saved
// for the till (any till opens it and takes the payment). Card tap is not set up.
import React from "react";
import { formatMoney } from "../../../../utils/fashion/money";
import { Back, Header } from "./FloorParts";

export default function FloorPay({ total, tillData, blocked, canSend, sending, onBack, onSend }) {
  return (
    <>
      <Header>
        <Back onClick={onBack}>Bag</Back>
        <b className="fp-fl-mk">Payment</b>
      </Header>
      <div className="fp-fl-body">
        <div className="fp-fl-due">
          <span className="fp-fl-lbl">To pay</span>
          <b className="fp-num fp-fl-disp">{formatMoney(total, tillData)}</b>
        </div>
        <div className="fp-fl-opts">
          <button type="button" className="fp-fl-pay" disabled={!canSend || Boolean(blocked) || sending} onClick={onSend}>
            <b>Send to till</b>
            <span>{canSend ? "The customer pays at any till. The bill waits there under From the floor." : "Not available on this device."}</span>
          </button>
          <button type="button" className="fp-fl-pay" disabled aria-disabled="true">
            <b>Tap to pay</b>
            <span>Not set up for this store</span>
          </button>
        </div>
        {blocked && (
          <p className="fp-fl-pill fp-fl-warn" role="status">
            {blocked}
          </p>
        )}
      </div>
    </>
  );
}
